export default "__VITE_ASSET__iy2d4ZY7__"